<template>
  <div class="related_box">
    <div class="related_title">相关推荐</div>
    <div class="related_list">
      <ul class="clearfix" :style="{ width: itemWidth * relatedList.length + 'px' }">
        <li class="related_item" :style="{ width: itemWidth + 'px' }" v-for="(item, index) in relatedList" :key="index" @click="toVideoDetail(item)">
          <div class="img_box">
            <div class="img">
              <img :src="item.imgUrl" alt="" :onerror="imgLoadError(item)" />
            </div>
          </div>
          <div class="title" v-text="item.title"></div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { deepClone } from "@/utils";
export default {
  name: "RelatedVideo",
  props: {
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      itemWidth: 200,
      relatedList: [],
    };
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.relatedList = deepClone(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 跳转详情页 */
    toVideoDetail(item) {
      if (item.type == 1) {
        this.$router.push({
          path: "/short_video_detail",
          query: {
            contentType: item.contentType || 9,
            contentId: item.contentId,
            cId: item.id || 0,
            type: item.type,
          },
        });
      } else {
        this.$router.push({
          path: "/video_detail",
          query: {
            contentType: item.contentType || 9,
            contentId: item.contentId,
            cId: item.id || 0,
            type: item.type,
          },
        });
      }
    },
  },
  created() {
    this.relatedList = deepClone(this.list);
  },
  mounted() {
    var _this = this;
    var w = document.body.clientWidth;
    w = w > 750 ? 750 : w;
    _this.itemWidth = w / 2 - 10;
    window.addEventListener("resize", function () {
      var w = document.body.clientWidth;
      w = w > 750 ? 750 : w;
      _this.itemWidth = w / 2 - 10;
    });
  },
};
</script>
<style scoped lang="scss">
.related_box {
  padding-top: 10px;
  padding-bottom: 20px;
  .related_title {
    color: #000;
    font-size: 18px;
  }
  .related_list {
    margin-top: 10px;
    overflow-x: auto;
    ul {
      .related_item {
        padding-right: 10px;
        float: left;
        .img_box {
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 56.25%;
          overflow: hidden;
          .img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-image: url(~@/assets/images/default_pic_16_9.png);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            display: flex;
            img {
              -o-object-fit: cover;
              object-fit: cover;
              min-width: 100%;
              min-height: 100%;
            }
          }
        }
        .title {
          height: 44px;
          line-height: 22px;
          margin-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: break-spaces;
        }
      }
    }
  }
}
</style>